import _ from "lodash";

const alfaberriesProcess = {
  namespaced: true,
  actions: {
    addRowsIn: ({ commit }, payload) => {
      commit("addRowsIn", payload);
    },
    addRowsOut: ({ commit }, payload) => {
      commit("addRowsOut", payload);
    },
    deleteRow: ({ commit }, payload) => {
      commit("deleteRow", payload);
    },
    updateProcess({ commit }, payload) {
      commit("updateProcess", payload);
    },
    getProductSet({ commit }, payload) {
      commit("getProductSet", payload);
    }
  },
  mutations: {
    getProductSet(state, payload) {
      state.product_set.spec_type = payload.spec_type;
      state.product_set.varieties = payload.varieties;
      state.product_set.containers = payload.bulk_containers;
      state.product_set.exportable_containers = payload.exportable_containers;
      state.product_set.product_types = payload.product_types;
      state.product_set.export_custom_fields = payload.export_custom_fields;
    },
    addRowsIn(state, payload) {
      state.form.contents_in.unshift(payload);
    },
    addRowsOut(state, payload) {
      state.form.contents_out.unshift(payload);
    },
    deleteRow(state, payload) {
      let array = [];
      if (payload.table_type === 0) {
        array = state.form.contents_in;
      } else {
        array = state.form.contents_out;
      }
      array.splice(payload.index, payload.index >= 0 ? 1 : 0);
    },
    updateProcess(state, payload) {
      state.form = payload;
    }
  },
  state: {
    container_net_kilograms: 0,
    product_set: {
      spec_type: [],
      varieties: [],
      containers: [],
      exportable_containers: [],
      export_custom_fields: [],
      product_types: []
    },
    form: {
      production_planning: {
        container: "",
        container_id: 0,
        product_id: 0,
        container_net_kilograms: ""
      },
      process_type: null,
      contents_in: [],
      contents_out: []
    }
  },

  // GETTERS

  getters: {
    countIn: (state) => {
      return state.form.contents_in.length;
    },
    countOut: (state) => {
      return state.form.contents_out.length;
    },
    totalInNet: (state) => {
      return state.form.contents_in.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
    },
    totalOutNet: (state) => {
      return state.form.contents_out
        .reduce(function (acc, item) {
          if (item.is_devolution != true) {
            return acc + parseFloat(item.net_kilograms);
          } else {
            return acc + parseFloat(0);
          }
        }, 0)
        .toFixed(2);
      // return state.form.contents_out.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
    },
    getDevolutionOutNet: (state) => () => {
      var sum = 0;
      for (const index in state.form.contents_out) {
        if (state.form.contents_out[index].is_devolution == true) {
          sum = sum + parseFloat(state.form.contents_out[index].net_kilograms);
        }
      }
      return sum.toFixed(2);
    },
    differenceNet: (state, getters) => {
      return (getters.totalInNet - getters.totalOutNet).toFixed(2);
    },

    totalInQuantity: (state) => {
      return state.form.contents_in.reduce((acc, item) => acc + item.quantity, 0);
    },
    totalOutQuantity: (state) => {
      return state.form.contents_out.reduce(function (acc, item) {
        if (item.is_devolution != true) {
          return acc + item.quantity;
        } else {
          return acc + 0;
        }
      }, 0);
    },
    totalExportable: (state) => {
      let value = state.form.contents_out
        .filter((item) => item.exportable === true)
        .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0)
        .toFixed(2);
      return isNaN(value) ? 0.0 : value;
    },
    totalQuantitySaleable: (state) => {
      let value = state.form.contents_out
        .filter(({ product_type }) => product_type.waste === false)
        .reduce((acc, item) => acc + parseInt(item.quantity), 0)
        .toFixed(0);
      return isNaN(value) ? 0 : value;
    },
    checkBrechaComercial: (state) => {
      let n = _.find(state.form.contents_out, (el) => {
        return el.product_type.name === "BRECHA COMERCIAL";
      });
      return !_.isEmpty(n);
    },
    totalWaste: (state) => {
      let value = state.form.contents_out
        .filter((item) => item.waste === true)
        .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0)
        .toFixed(2);
      return isNaN(value) ? 0.0 : value;
    },
    currentLotInProcess: (state) => {
      let currentLot;
      const lenght = state.form.contents_in.length;
      if (lenght > 0) {
        currentLot = {
          lot_id: parseInt(state.form.contents_in[lenght - 1].lot_id),
          lot_number: state.form.contents_in[lenght - 1].lot_number,
          product_id: parseInt(state.form.contents_in[lenght - 1].product_id)
        };
      } else {
        currentLot = "-";
      }
      return currentLot;
    },

    lotsInProcess: (state) => {
      // Se agrupa por Lote-Código: 4YO13E-3020000 y se entrega la información necesaria para que los botones funcionen
      return _(state.form.contents_in)
        .groupBy((i) => i.lot_number)
        .map((content, id) => ({
          lot: id,
          lot_id: parseInt(_.map(content, "lot_id")[0]),
          product_id: parseInt(_.map(content, "product_id")[0]),
          product_name: _.map(content, "product_name")[0],
          net_kilograms_sum_in: _.sumBy(content, (item) => Number(item.net_kilograms)).toFixed(2),
          net_kilograms_sum_out: state.form.contents_out
            .map((i) => ({
              lot: i.lot_number,
              net_kilograms: i.net_kilograms
            }))
            .filter((i) => i.lot === id)
            .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0)
            .toFixed(2)
        }))
        .value();
    }
  }
};

export default alfaberriesProcess;
